import React from 'react';
import { Card } from '../../../types/interfaces';

interface AddToFavoritesButtonProps {
  item: Card;
  isFavorite?: boolean;
  onToggle?: (itemId: number) => void;
}

export function AddToFavoritesButton({ item, isFavorite = false, onToggle }: AddToFavoritesButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onToggle) {
      onToggle(item.id);
    }
  };

  // 4 состояния по макету (Bitrix 35181, комментарий Виталия 29.06):
  // обычное — серый фон и серая обводка; hover — красный контур и фон;
  // нажатие и «уже в избранном» — закрашенное красное сердце на красном фоне.
  const stateClasses = isFavorite
    ? 'bg-[#E3282A1F] text-[#E3282A]'
    : 'bg-[#F2F3F5] text-[#9CA3AF] hover:bg-[#E3282A12] hover:text-[#E3282A] active:bg-[#E3282A1F] active:[&_path]:fill-current';

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`cursor-pointer transition-colors duration-200 rounded-full p-2 flex items-center justify-center ${stateClasses}`}
      title={isFavorite ? 'Удалить из избранного' : 'Добавить в избранное'}
      aria-pressed={isFavorite}
      aria-label={isFavorite ? 'Удалить из избранного' : 'Добавить в избранное'}
    >
      <svg width="15" height="13" viewBox="0 0 15 13" aria-hidden="true">
        <path
          d="M12.992 1.09881C10.4187 -0.593593 8.15953 1.7795 7.50033 2.58542C6.84393 1.77714 4.59272 -0.601627 2.00795 1.09881C0.919779 1.81447 0.403571 2.88241 0.514836 4.18662C0.775157 7.23662 4.48425 11.2071 7.38976 12.4724C7.40982 12.483 7.43128 12.4906 7.45321 12.4948C7.46954 12.4983 7.4861 12.5 7.50243 12.5C7.54301 12.5 7.58314 12.4894 7.61882 12.4686C10.5232 11.1993 14.225 7.23355 14.4851 4.18662C14.5966 2.88217 14.0799 1.81447 12.992 1.09881Z"
          fill={isFavorite ? 'currentColor' : 'none'}
          stroke="currentColor"
          strokeWidth="1"
          className="transition-colors duration-200"
        />
      </svg>
    </button>
  );
}
